import {
    boardcastDataResponse,
    cancelSessionData,
    getEnrollAvailability,
    hostSession,
    joinSession,
    sessionAttendence,
    sessionWatchURLDataResponse,
    setEnrollBrokerSessionResponse,
} from "../../redux/events/actions";
import { Popover, PopoverHeader, PopoverBody } from "reactstrap";
import { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { getEnrollBrokerSession } from "../../redux/events/actions";
import { cartPageDataResponse } from "../../redux/checkout/actions";
import { clickStreamUser, convertTimeFormat, getProcureInfo, ProductCardPriceInfo, SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import VideoModal from "../../components/modal/VideoModal";
import { addToCart } from "../../redux/product/actions";
import CartPopUpComponent from "../../components/NewDesign/DetailPage/CartPopUp/CartPopUpComponent";

class CustomEvent extends Component {

    constructor(props) {
        super(props);
        // console.log('props', props)
        this.state = {
            popoverOpen: false,
            confirmModal: false,
            videoData: {},
            headerProdData:{},
            isOpen:false

        };
        this.toggle = this.toggle.bind(this);
        this.categorySelect = this.categorySelect.bind(this);
    }

    toggle(state) {
        this.setState({
            popoverOpen: state,
            // popoverOpen: !this.state.popoverOpen,
        });
    }

    toggleConfirmModal = () => {
        this.setState({
            confirmModal: !this.state.confirmModal,
            videoData: {},
        });
    };

    categorySelect(category) {
        this.props.event.onCategorize(this.props.event, category);
        this.setState({ popoverOpen: false });
    }

    joinSession(eventData) {

        if (eventData.is_boardcast) {
            this.boardcastSession(eventData);
        } else {
            // console.log(eventData)
            if (eventData.join_url) {
                eventData.joinSessionWithURL({
                    join_url: eventData.join_url
                })
            } else {
                eventData.showLoader();
                this.props.joinZoomSession({
                    module: "joinZoomMeeting",
                    postData: {
                        user_id: eventData.userId,
                        meeting_id: eventData.meetingId,
                        session_id: eventData.sessionId,
                        segment_id: eventData.segmentId,
                    },
                });
                // if (eventData.meetinId) {
                // } else {
                //     eventData.showAlert("Host has not yet started the meeting.");
                // }
            }
        }
    }

    boardcastSession(eventData) {
        //console.log(eventData)
        this.props.boardcastInfo(eventData);
        if (eventData.isMobile) {
            eventData.navigate("/session/broadcast/mobile/watch");
        } else {
            eventData.navigate("/session/broadcast/watch");
        }
    }

    registerSession(eventData) {
        // console.log('call to register event', eventData)
        // eventData.showLoader();
        this.setState({ popoverOpen: false });
        eventData.registerSessionConfirmation(eventData)
        return;

        clickStreamUser("register-button-clicked", {
            event_id: eventData.eventId,
            session_id: eventData.eventId,
            session_name: eventData.title,
            email: localStorage.getItem(SessionKeys.EMAIL),
            type: eventData.source === "broker" ? "broker" : "xsel",
        });
        this.props.enrollSession({
            module: "enrollBrokerSession",
            postData: {
                token: eventData.isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                session_id: eventData.sessionId,
                event_id: eventData.eventId,
                type: eventData.source === "broker" ? "broker" : "xsel",
            },
        });
    }

    proceedToBook(eventData) {
        // console.log('call to proceed to book', this.props)
        eventData.showLoader();
        // return;
        clickStreamUser("proceed-to-book-session", {
            event_id: eventData.eventId,
            session_id: eventData.sessionId,
            session_name: eventData.title,
            email: localStorage.getItem(SessionKeys.EMAIL),
        });
        if (eventData.delivery_mode === 'virtual_broadcast') {
            eventData.navigate(
                `/shopping/${eventData.productId}?addToCart=${eventData.is_addToCart}&source=session`
            );
        } else {
            this.props.enrollAvailability({
                module: "checkEnrollAvailability",
                postData: {
                    token: eventData.isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    session_id: eventData.sessionId,
                    event_id: eventData.eventId,
                    type: eventData.source === "broker" ? "broker" : "xsel",
                }
            })
        }
    }

    cancelSession(eventData) {
        eventData.cancelSessionConfirmation(eventData)
        // if (eventData.source === 'broker') {

        // } else {
        //   this.props.cancelSessionInfo({
        //     module: "sessionCancel",
        //     postData: {
        //       token: eventData.isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //       session_id: eventData.sessionId,
        //       event_id: eventData.eventId,
        //     },
        //   });
        // }

    }

    watchSession(eventData) {
        this.props.watchSessionInfo({
            id: eventData.sessionId,
            title: eventData.title,
            watch_url: eventData.watch_url,
        });
        eventData.navigate("/session/watch");
    }

    hostSession(eventData) {
        if (eventData.is_boardcast) {
            this.boardcastSession(eventData);
        } else {
            if (eventData.start_url) {
                eventData.hostSessionWithURL({
                    start_url: eventData.start_url
                })
            } else {
                this.props.startHost({
                    module: "createZoomMeeting",
                    postData: {
                        user_id: eventData.userId,
                        host_zoom_id: eventData.hostZoomId,
                        meeting_topic: eventData.title,
                        meeting_agaenda: eventData.title,
                        meeting_startdate: moment
                            .utc(eventData.startUTC)
                            .format("YYYY-MM-DD HH:mm"),
                        duration: _.toNumber(eventData.durationValue),
                        session_id: eventData.sessionId,
                        segment_id: eventData.segmentId,
                    },
                });
            }
        }
    }

    redirectToEventDetail() {
        let userRole = this.props.event.userRole;
        let navigate = this.props.event.navigate;
        let eventId = this.props.event.eventId;
        let eventSource = this.props.event.source;
        let eventCode = this.props.event.eventCode;
        if (userRole === 'realtor' || userRole === 'manager' || userRole === 'customer') {
            if (eventSource === 'broker') {
                let paramsReq ={
                    event_id: eventId,
                    source: "broker"
                  }
                  let jsonString = JSON.stringify(paramsReq);
                  let encodedUrl = btoa(jsonString);
                navigate(`/event-detail?c=${encodedUrl}`);
            } else {
                let paramsReq ={
                    event_id: eventId,
                    event_code: eventCode,
                    source: "ecom"
                  }
                  let jsonString = JSON.stringify(paramsReq);
                  let encodedUrl = btoa(jsonString);
                    navigate(`/event-detail?c=${encodedUrl}`)
            }
        }
    }

    proceedToPurchase (sessionData, priceInfo) {
        clickStreamUser("purchase-button-clicked", {
          event_id: sessionData.eventId,
          session_id: sessionData.sessionId,
          session_name: sessionData.title,
          type: "xsel",
        });
        let tags = [];
        let logoURL = "";
        if (!_.isEmpty(sessionData.provider)) {
          tags.push(sessionData.provider.provider_display_name);
          logoURL = sessionData.provider.provider_img;
        }
        if (sessionData.host) {
          tags.push(sessionData.host);
        }
        let deliveryMode =
          sessionData.delivery_mode && sessionData.delivery_mode == "face_to_face"
            ? "In-Person"
            : sessionData.delivery_mode === "blended_session"
              ? "In-Person/Virtual"
              : sessionData.delivery_mode &&
                (sessionData.delivery_mode == "virtual_interactive" ||
                  sessionData.delivery_mode == "virtual_broadcast")
                ? "Live"
                : sessionData.delivery_mode
                  ? sessionData.delivery_mode
                  : "";
        tags.push(deliveryMode);
        if (sessionData.duration) {
          let timeDuration = convertTimeFormat(
            sessionData.duration,
            true
          );
          tags.push(timeDuration);
        }
        // tags.push(`${sessionData.views} View${sessionData.views > 1 ? 's' : ''}`)
        this.setState({
            isOpen: true,
            headerProdData:{
                id: sessionData.productId,
                title: sessionData.title,
                logoURL: logoURL,
                logoAltText: "ED",
                bannerURL: sessionData.event_thumbnail,
                tagsArray: tags,
                description: sessionData.event_desc,
                duration: "",
                view: "",
                price: priceInfo.price,
                isPaid: !priceInfo.isFree,
                priceInfo: priceInfo,
                cancel_request: sessionData.cancel_request,
              }
        });
        
      };

    renderButton() {
        // console.log('EVENT CLICKED', this.props.delivery_mode)
        
        if (!this.props.event.is_host && !_.isEmpty(this.props.event?.purchased_info) &&
            !this.props.event?.purchased_info?.isFree
            && this.props.event?.purchased_info?.price > 0) {
            return (<>
                {this.props.event.session_status === 1 && <button className={'btn-join active'}
                    onClick={() => this.proceedToPurchase(this.props.event,this.props.event.purchased_info)}>
                    Purchase
                </button>}
                <button className={"btn-join active"}
                    onClick={() => this.redirectToEventDetail()}
                >View</button>
            </>)
        } else if (this.props.event.is_registered && this.props.event.is_participant) {
            // console.log('this.props.event', this.props.event)
            if (this.props.event.delivery_mode === "face_to_face") {
                const startTime = moment(`${this.props.event.start}`).subtract(
                    30,
                    "minutes"
                );
                const endTime = moment(`${this.props.event.end}`);
                const currentTime = moment(this.props.event.current_time);
                if (currentTime.isBefore(startTime)) {
                    if (this.props.event.userRole === 'instructor' ||
                        this.props.event.userRole === "host") {
                        return (
                            <>
                                <button className={"btn-join active"}
                                >View</button>
                            </>
                        )
                    } else {
                        return (
                            <>
                                <button className={"btn-join active"}
                                    onClick={() => this.redirectToEventDetail()}
                                >View</button>
                                <button
                                    className={this.props.event.cancel_request?"btn-join disable-button":"btn-join active"}
                                    title={this.props.event?.cancel_request?"Your session cancellation request is still pending.":""}
                                    onClick={() =>{
                                        if(this.props.event.cancel_request){
                                            return;
                                        }
                                        this.cancelSession(this.props.event)}}
                                >
                                    Cancel
                                </button>
                            </>
                        )
                    }
                } else {
                    if (this.props.event.userRole === 'instructor' ||
                        this.props.event.userRole === "host") {
                        return (
                            <>
                                <button className={"btn-join active"}
                                >View</button>
                            </>
                        )
                    } else {
                        return (
                            <>
                                <button className={"btn-join active"}
                                    onClick={() => this.redirectToEventDetail()}
                                >View</button>
                            </>
                        )
                    }
                }
            } else if (this.props.event.tense === "past") {
                if (this.props.event.watch_url) {
                    return (
                        <button
                            className={"btn-join active"}
                            onClick={() => this.watchSession(this.props.event)}
                        >
                            Watch
                        </button>
                    );
                } else {
                    return <>{/* Session has ended. {this.props.event.watch_url} */}</>;
                }
            } else if (this.props.event.tense === "future") {
                return (
                    <>
                        <button className={"btn-join"}>Join</button>
                        <button
                        className={this.props.event.cancel_request?"btn-join disable-button":"btn-join active"}
                        title={this.props.event?.cancel_request?"Your session cancellation request is still pending.":""}
                            onClick={() =>{
                                if(this.props.event.cancel_request){
                                    return;
                                }
                                this.cancelSession(this.props.event)}}
                        >
                            Cancel
                        </button>
                    </>
                );
            } else {
                const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const startTime = moment(`${this.props.event.start}`).subtract(
                    1,
                    "hour"
                );
                const endTime = moment(`${this.props.event.end}`);
                const currentTime = moment(this.props.event.current_time);
                /**
                 * Current time should be between startTime (ie. one hour before actual start time)
                 * and actual endTime
                 */
                if (currentTime.isBetween(startTime, endTime)) {
                    return (
                        <>
                            <button
                                className={"btn-join active"}
                                onClick={() => this.joinSession(this.props.event)}
                            >
                                Join
                            </button>
                        </>
                    );
                } else if (currentTime.isAfter(endTime)) {
                    if (this.props.event.watch_url) {
                        return (
                            <button
                                className={"btn-join active"}
                                onClick={() => this.watchSession(this.props.event)}
                            >
                                Watch
                            </button>
                        );
                    }
                } else {
                    return (
                        <>
                            <button className={"btn-join"}>Join</button>
                            <button
                            className={this.props.event.cancel_request?"btn-join disable-button":"btn-join active"}
                            title={this.props.event?.cancel_request?"Your session cancellation request is still pending.":""}
                                onClick={() => {
                                    if(this.props.event.cancel_request){
                                        return;
                                    }
                                    this.cancelSession(this.props.event)}}
                            >
                                Cancel
                            </button>
                        </>
                    );
                }
            }
        } else if (this.props.event.is_host) {
            if (this.props.event.delivery_mode === "face_to_face" || this.props.event.delivery_mode === "blended_session") {
                return (
                    <>
                        {(this.props.event.userRole === "host" || this.props.event.userRole === "instructor")?"":<button className={"btn-join active"}>View</button>}
                    </>
                )
            } else if (this.props.event.tense === "future") {
                return (
                    <>
                        <button className={"btn-join"}>Host</button>
                        {
                            this.props.event.userRole === 'realtor' && this.props.event.userRole === 'manager'
                                ?
                                <button className={"btn-join"}>View</button>
                                : ""
                        }
                    </>
                );
            } else if (this.props.event.tense === "present") {
                const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

                const startTime = moment(`${this.props.event.start}`).subtract(
                    1,
                    "hour"
                );
                const endTime = moment(`${this.props.event.end}`);
                const currentTime = moment(this.props.event.current_time);
                /**
                 * Current time should be between startTime (ie. one hour before actual start time)
                 * and actual endTime
                 */
                if (currentTime.isBetween(startTime, endTime)) {
                    return (
                        <>
                            <button
                                className={"btn-join active"}
                                onClick={() => this.hostSession(this.props.event)}
                            >
                                Host
                            </button>
                            {
                                this.props.event.userRole === 'realtor' && this.props.event.userRole === 'manager'
                                    ?
                                    <button className={"btn-join"}>View</button>
                                    : ""
                            }
                        </>
                    );
                } else {
                    return (
                        <>
                            <button className={"btn-join"}>Host</button>
                            {
                                this.props.event.userRole === 'realtor' && this.props.event.userRole === 'manager'
                                    ?
                                    <button className={"btn-join"}>View</button>
                                    : ""
                            }
                        </>
                    );
                }
            } else {
                return (
                    <>
                        {
                            this.props.event.userRole === 'realtor' && this.props.event.userRole === 'manager'
                                ?
                                <button className={"btn-join"}>View</button>
                                : ""
                        }
                    </>
                )
            }
        } else if (this.props.event.tense === "past") {
            return <>{
                /* Session has ended. */
            }</>;
        } else if (this.props.event?.purchased_info?.isFree) {
            if (
                this.props.event.userRole === "instructor" ||
                this.props.event.userRole === "host" ||
                this.props.event.userRole === "admin" ||
                this.props.event.userRole === "broker"
            ) {
                const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const startTime = moment(`${this.props.event.start}`).subtract(
                    1,
                    "hour"
                );
                const endTime = moment(`${this.props.event.end}`);
                const currentTime = moment(this.props.event.current_time);

                if (currentTime.isBetween(startTime, endTime)) {
                    return (
                        <button
                            className={"btn-join active"}
                            onClick={() => this.joinSession(this.props.event)}
                        >
                            Join
                        </button>
                    );
                } else {
                    return (
                        <button
                            className={"btn-join"}
                            onClick={() => this.joinSession(this.props.event)}
                        >
                            Join
                        </button>
                    );
                }
            } else {
                if (this.props.event.showRegister ||
                    this.props.event.endTimeCrossed) {
                    return (
                        <button
                            className={"btn-join active"}
                            onClick={() => this.registerSession(this.props.event)}
                        >
                            Register
                        </button>
                    );
                }
            }
        } else if (this.props.event.source === 'broker') {
            if (this.props.event.showRegister ||
                this.props.event.endTimeCrossed) {
                return (
                    <button
                        className={"btn-join active"}
                        onClick={() => this.registerSession(this.props.event)}
                    >
                        Register
                    </button>
                );
            }
        } else if (this.props.event.is_paid && !this.props.event.is_registered) {
            return (
                <>
                    {/* <button
                  className={"btn-join active"}
                  onClick={() => this.registerSession(this.props.event)}
                >
                  Register
                </button> */}
                    {/* <button className={'btn-join active'}
                  onClick={() => this.proceedToBook(this.props.event)}>
                    Book
                  </button> */}
                    {/* <button className={"btn-join active"}
                                    onClick={() => this.redirectToEventDetail()}
                                >View</button> */}
                </>
            );
        }

        // console.log('EVENT CLICKED NOT PAID', this.props.event.title)

    }

    renderCalendarCard = () => {
        return (
            <div className="event-title"
                onMouseEnter={() => this.toggle(true)}
                onMouseLeave={() => this.toggle(false)}
                onClick={() => {
                    this.setState({
                        popoverOpen: false,
                    });
                }}
                id={`popover-${this.props.event.sessionId}-${this.props.event.segmentId}`}
            >
                <div className="d-flex justify-content-between flex-column w-100 event-block">
                    <div className="cal-event-title"
                        onClick={() => {
                            this.redirectToEventDetail()
                        }}
                    >
                        {this.props.event.title}
                    </div>
                    <div className="mt-1 d-flex eventbtn-cal">
                        {this.renderButton()}
                        
                        {
                            (_.isEmpty(this.props.event?.purchased_info) ||
            (this.props.event?.purchased_info?.isFree && this.props.event.purchased_info?.price===0))&&(this.props.event.delivery_mode !== 'face_to_face' ||
                                (this.props.event.delivery_mode === 'face_to_face' &&
                                    !this.props.event.is_registered))
                                ?
                                (this.props.event.userRole === 'realtor' || this.props.event.userRole === 'manager' || this.props.event.userRole === "customer") ?
                                    <div>
                                        <button className="btn-join view-btn"
                                            onClick={() => this.redirectToEventDetail()}>
                                            View
                                        </button>
                                    </div>
                                    : ""
                                : ""
                        }
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div>
                <VideoModal
                    confirmModal={this.state.confirmModal}
                    setConfirmModal={this.toggleConfirmModal}
                    videoData={this.state.videoData}
                />
                {this.renderCalendarCard()}

                <Popover
                    placement="auto"
                    className="popover-container"
                    isOpen={this.state.popoverOpen}
                    target={`popover-${this.props.event.sessionId}-${this.props.event.segmentId}`}
                    toggle={() => this.toggle(true)}
                >
                    <PopoverHeader className="events-popup"
                        dangerouslySetInnerHTML={{
                            __html: `${this.props.event.eventName} (
                                ${moment(`${this.props.event.sessionStartDate}`).format(
                                "DD MMM YYYY"
                            )} - ${moment(`${this.props.event.sessionEndDate}`).format(
                                "DD MMM YYYY"
                            )}
                            )`
                        }}
                    >
                    </PopoverHeader>
                    <PopoverBody className="events-popup_body">
                        <div className="d-flex gap-2 align-items-start mb-2">
                            <span className="titlesub-cal">
                                {this.props.event.segmentTitle} #{this.props.event.segmentNumber}&nbsp;of&nbsp;{this.props.event.totalSegment}
                            </span>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                            <div className="side-image">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="31.105"
                                    height="21.105"
                                    viewBox="0 0 11.105 11.105"
                                >
                                    <path
                                        id="clock-time-four"
                                        d="M7.553,2a5.553,5.553,0,1,0,5.553,5.553A5.569,5.569,0,0,0,7.553,2M9.94,9.33,7,7.719V4.776H7.83V7.22l2.5,1.388Z"
                                        transform="translate(-2 -2)"
                                        fill="#415385"
                                    />
                                </svg>
                            </div>
                            <span className="side-text">
                                {this.props.event.segmentStart.format('ddd, MMM DD YYYY') + ' at '
                                    + this.props.event.segmentStart.format('hh:mm a') + ' to ' +
                                    this.props.event.segmentEnd.format('hh:mm a') + ' ' +
                                    this.props.event.segmentStart.format('z')}
                            </span>
                        </div>
                        {/* <div className="d-flex gap-2 align-items-start mb-2">
              <div className="side-image">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="31.105"
                  height="21.105"
                  viewBox="0 0 11.105 11.105"
                >
                  <path
                    id="clock-time-four"
                    d="M7.553,2a5.553,5.553,0,1,0,5.553,5.553A5.569,5.569,0,0,0,7.553,2M9.94,9.33,7,7.719V4.776H7.83V7.22l2.5,1.388Z"
                    transform="translate(-2 -2)"
                    fill="#415385"
                  />
                </svg>
              </div>
              <div className="side-text">
                <span>
                  {moment(`${this.props.event.sessionEndDate}`).format(
                    "DD MMM YYYY"
                  ) +
                    " at " +
                    moment(`${this.props.event.sessionEndDate}`).format(
                      "hh:mm A"
                    ) +
                    " " +
                    this.props.event.sessionEndTimezone}
                </span>
              </div>
            </div> */}
                        <div className="d-flex gap-2 align-items-center">
                            <div className="side-image">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="21.623"
                                    height="22.159"
                                    viewBox="0 0 8.623 12.159"
                                >
                                    <g
                                        id="Icon_feather-map-pin"
                                        data-name="Icon feather-map-pin"
                                        transform="translate(-4.5 -1.499)"
                                    >
                                        <path
                                            id="Exclusion_6"
                                            data-name="Exclusion 6"
                                            d="M15192.567,408.817h0c-.043-.045-4.309-4.523-4.309-7.844a4.312,4.312,0,1,1,8.623,0c0,3.317-4.27,7.8-4.312,7.844Zm0-9.6a1.752,1.752,0,1,0,1.75,1.754A1.757,1.757,0,0,0,15192.571,399.218Z"
                                            transform="translate(-15183.758 -395.16)"
                                            fill="#415385"
                                        />
                                    </g>
                                </svg>
                            </div>
                            <div className="side-text text-capitalize">
                                {this.props.event.delivery_mode === "face_to_face" ? `In Person (${this.props.event.location})` : this.props.event.delivery_mode === "virtual_interactive" || this.props.event.delivery_mode === "virtual_broadcast" ? "Virtual"
                                    : this.props.event.tense === 'past' ? this.props.event.watch_url ? 'Recorded' : 'Live' : 'Live'}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-4">
                            <div>
                             
                                    <>
                                        <span className="popover-price">


                                        {!_.isEmpty(this.props.event.purchased_info)  ? this.props.event.session_status===0 && !this.props.event.purchased_info?.isPurchased && !this.props.event.purchased_info?.isFree ?"":
                                        ProductCardPriceInfo(
                                          this.props.event.purchased_info.showText,
                                          this.props.event.purchased_info.textColor
                                        ):""}
                                        </span>
                                    </>
                               
                            </div>
                            {/* <div>
                <button className="btn btn-primary-complete"
                onClick={() => this.redirectToEventDetail()}>
                  View More
                </button>
              </div> */}
                            {/* {this.renderButton()} */}
                        </div>
                    </PopoverBody>
                </Popover>
                <CartPopUpComponent
                        isOpen={this.state.isOpen}
                        productData={this.state.headerProdData}
                        closeAction={() => this.setState({isOpen:false})}
                        isSubscription={false}
                        setMainPageLoading={()=>{}}
                      />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        joinZoomSession: (data) => {
            dispatch(joinSession(data));
        },
        enrollSession: (data) => {
            dispatch(getEnrollBrokerSession(data));
        },
        enrollAvailability: (data) => {
            dispatch(getEnrollAvailability(data))
        },
        payForSession: (data) => {
            dispatch(setEnrollBrokerSessionResponse(data));
        },
        cartPageResponse: (data) => {
            dispatch(cartPageDataResponse(data));
        },
        sessionMarkAttendence: (data) => {
            dispatch(sessionAttendence(data));
        },
        cancelSessionInfo: (data) => {
            dispatch(cancelSessionData(data));
        },
        addToCartData: (data) => {
            dispatch(addToCart(data));
        },
        startHost: (data) => {
            dispatch(hostSession(data));
        },
        watchSessionInfo: (data) => {
            dispatch(sessionWatchURLDataResponse(data));
        },
        boardcastInfo: (data) => {
            dispatch(boardcastDataResponse(data));
        },
    };
};

const mapStateToProps = (state) => {
    return {
        state: state.auth.authBroker,
        userDetail: state.user.userBroker?.payload?.payload,
        isPremiumUser: state.user.isPremiumUser,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomEvent);
